<template>
    <el-scrollbar ref="scroll">
        <div class="view-modal window-scorll">
            <div class="container">
                <el-container class="mb-10 container-modal">
                    <el-header>Header</el-header>
                    <el-container>
                        <el-container>
                            <el-aside width="200px">Aside</el-aside>
                            <el-main>Main</el-main>
                        </el-container>
                        <el-footer>Footer</el-footer>
                    </el-container>
                </el-container>

                <el-container class="mb-10 container-modal">
                  <el-header>Header</el-header>
                  <el-main>Main</el-main>
                </el-container>

                <el-container class="mb-10 container-modal">
                  <el-header>Header</el-header>
                  <el-main>Main</el-main>
                  <el-footer>Footer</el-footer>
                </el-container>

                <el-container class="mb-10 container-modal">
                  <el-aside width="200px">Aside</el-aside>
                  <el-main>Main</el-main>
                </el-container>

                <el-container class="mb-10 container-modal">
                  <el-header>Header</el-header>
                  <el-container>
                    <el-aside width="200px">Aside</el-aside>
                    <el-main>Main</el-main>
                  </el-container>
                </el-container>

                <el-container class="mb-10 container-modal">
                  <el-header>Header</el-header>
                  <el-container>
                    <el-aside width="200px">Aside</el-aside>
                    <el-container>
                      <el-main>Main</el-main>
                      <el-footer>Footer</el-footer>
                    </el-container>
                  </el-container>
                </el-container>

                <el-container class="mb-10 container-modal">
                  <el-aside width="200px">Aside</el-aside>
                  <el-container>
                    <el-header>Header</el-header>
                    <el-main>Main</el-main>
                  </el-container>
                </el-container>

                <el-container class="mb-10 container-modal">
                  <el-aside width="200px">Aside</el-aside>
                  <el-container>
                    <el-header>Header</el-header>
                    <el-main>Main</el-main>
                    <el-footer>Footer</el-footer>
                  </el-container>
                </el-container>
            </div>
        </div>
    </el-scrollbar>
</template>
<script>
    import $ from 'jquery'
    export default{
        data(){
            return {}
        },
        methods:{
            // handleScroll() {
            //     //方法一
            //     //var top = Math.floor(document.body.scrollTop || document.documentElement.scrollTop || window.pageXOffset)
            //     //console.log(top)

            //     //方法二
            //     //如果获取不到高度可换成 
            //     this.$nextTick(()=>{
            //         var top = document.body.scrollTop || document.documentElement.scrollTop || window.pageXOffset
            //         console.log(top)
            //     })
            // }
        },
        mounted(){

            const menu_lists = [
                {
                    key:1,
                    title:'功能1',
                    callback() {
                        console.log(11111)
                    }
                },
                {
                    key:2,
                    title:'功能2',
                    callback() {
                        console.log(22222)
                    }
                },
                {
                    key:3,
                    title:'功能3',
                    callback() {
                        console.log(33333)
                    }
                },
                {
                    key:4,
                    title:'功能4',
                    callback() {
                        console.log(44444)
                    }
                },
                {
                    key:5,
                    title:'功能5',
                    callback() {
                        console.log(55555)
                    }
                },
            ]
            this.$oncontextMenu(menu_lists);

            let that = this;
            $('.el-scrollbar__wrap').scroll(() => {
                        var he=$('.window-scorll').offset().top;
                        // console.log(he)
                        // if(he < 40){
                        //     that.main_header_active = true;
                        // }else{
                        //     that.main_header_active = false;
                        // }
                    });
            // window.addEventListener('scroll', () => {
            //     console.log(that.el_scrollbar_data.m_y / 100 * that.el_scrollbar_data.p_h)
            // }, true)

            this.$parent.main_header_active = false;
        },
        created(){
            this.$parent.routerLoading();
        },
    }
</script>
<style scoped>
.container-modal{
    width: 45%;
    margin-right: 5%;
    float: left;
    height: 500px;
}
.el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }
  
.el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
}
  
.el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
}
  
body > .el-container {
    margin-bottom: 40px;
}
  
.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
    line-height: 260px;
}
  
.el-container:nth-child(7) .el-aside {
    line-height: 320px;
}
</style>


// WEBPACK FOOTER //
// src/components/main-content/container.vue